import { AbstractQueryAction, ActionData } from '../../http/data_query';
import { ManyRelationsWithDocuments } from './common';
import { normalizeSchemaName } from '../tools';

export class RawBuilder implements AbstractQueryAction {

  actionData: any = null;
  payload: any = null;

  constructor(
    private queryName: string | null,
    private actionName: string | null,
  ) { }

  action(data: any) {
    this.actionData = data;
    return this;
  }

  body(payload: any) {
    this.payload = payload;
    return this;
  }

  serialize(): ActionData {
    const query: any = {
      action: this.actionName,
      name: this.queryName,
      params: this.actionData,
      ...(this.payload || {})
    };

    return query;
  }

}
